var scope_0 = require('/vercel/path2/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/100865f0e810782852a17f433882ce78.js').default;
var scope_1 = require('/vercel/path2/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1060207ad95ea97159019d9d2fcee165.js').default;
var scope_2 = require('/vercel/path2/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/15485f6027d0a9a3ad7b58188a486917.js').default;
var scope_3 = require('/vercel/path2/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/17b916f8f67e6d8eb57603c6082286a6.js').default;
var scope_4 = require('/vercel/path2/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/17e5476475cf75ad5526f04e991ba665.js').default;
var scope_5 = require('/vercel/path2/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/4a24d4e69a7334326da5ab7623bd3e70.js').default;
var scope_6 = require('/vercel/path2/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/5026a23c36ceec899a45af118ed5c1e3.js').default;
var scope_7 = require('/vercel/path2/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/5e6b13134c94ede48153c6f04ff79bc3.js').default;
var scope_8 = require('/vercel/path2/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/6f3e448745da02487bd0209f36b80c63.js').default;
var scope_9 = require('/vercel/path2/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/77ff1dc82d1a86500542406d12d71797.js').default;
var scope_10 = require('/vercel/path2/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/78eed6ba33a005fe13e7abbc6cad0883.js').default;
var scope_11 = require('/vercel/path2/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/79a9d6e99a623b9f7ab70d73c999d9a2.js').default;
var scope_12 = require('/vercel/path2/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/7c479d4cedf12d796228ff152ba96963.js').default;
var scope_13 = require('/vercel/path2/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/913ec14752c102440de8104346ffd3c7.js').default;
var scope_14 = require('/vercel/path2/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/97c95f5cae86a000eaa007ba1459c7e5.js').default;
var scope_15 = require('/vercel/path2/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ac82bd3c8815231d7bf51bafa38e19da.js').default;
var scope_16 = require('/vercel/path2/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c2c012e0c831c667f8fef7c61015ffa5.js').default;
var scope_17 = require('/vercel/path2/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c6de2ebafd2b3e1ef2bc985e1d2216ab.js').default;
var scope_18 = require('/vercel/path2/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/cdaef497991d86f6cee4215cf1539b70.js').default;
var scope_19 = require('/vercel/path2/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d9dd6b86f1518a953f50756c734e46b9.js').default;
var scope_20 = require('/vercel/path2/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/dace6ed3e464770aeb64ed53b027ddf1.js').default;
var scope_21 = require('/vercel/path2/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e1e11d5d1e7b647e001c21d251568632.js').default;
var scope_22 = require('/vercel/path2/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f49417c11478d265a37950183cce37db.js').default;
var scope_23 = require('/vercel/path2/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f879c7912d2584723248fa470d12a92e.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5,
scope_6,
scope_7,
scope_8,
scope_9,
scope_10,
scope_11,
scope_12,
scope_13,
scope_14,
scope_15,
scope_16,
scope_17,
scope_18,
scope_19,
scope_20,
scope_21,
scope_22,
scope_23 )
    